<script setup lang="ts">
    const { lang } = useLanguage();

    const chatbotLoaded = useState<boolean>('loadedChatBot', () => false);
    const runtimeConfig = useRuntimeConfig();

    function loadScript(src: string, id: string) {
        return new Promise<void>((resolve, reject) => {
            const existing = document.getElementById(id) as HTMLScriptElement | null;
            if (existing) return resolve();

            const s = document.createElement('script');
            s.id = id;
            s.src = src;
            s.defer = true;
            s.addEventListener('load', () => resolve());
            s.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)));

            document.head.appendChild(s);
        });
    }

    function initEmbeddedMessaging() {
        try {
            // @ts-expect-error Salesforce global
            const embeddedserviceBootstrap = window.embeddedservice_bootstrap;
            if (!embeddedserviceBootstrap) return;

            embeddedserviceBootstrap.settings.language = lang.value || 'de';

            embeddedserviceBootstrap.init(
                runtimeConfig.public.chatbot.id,
                'Medice_Enhanced_Chat',
                runtimeConfig.public.chatbot.chatUrl,
                {
                    scrt2URL: runtimeConfig.public.chatbot.scrt2URL
                }
            );

            chatbotLoaded.value = true;
        } catch (err) {
            console.error('Error loading Embedded Messaging:', err);
        }
    }

    function destroyEmbeddedMessaging() {
        try {
            const containers = document.querySelectorAll(
                '[id^="embeddedMessaging"], .embeddedMessaging, iframe[src*="salesforce"]'
            );
            containers.forEach((el) => el.remove());

            const script = document.getElementById('embedded-messaging-bootstrap');
            if (script) script.remove();

            // @ts-expect-error Salesforce global
            if (window.embeddedservice_bootstrap) {
                try {
                    // @ts-expect-error Salesforce global
                    window.embeddedservice_bootstrap.destroy?.();
                } catch (_) {
                    // silent error catching
                }

                // @ts-expect-error Salesforce global
                delete window.embeddedservice_bootstrap;
            }

            chatbotLoaded.value = false;
        } catch (err) {
            console.warn('Error destroying Embedded Messaging:', err);
        }
    }

    onMounted(async () => {
        await loadScript(
            `${runtimeConfig.public.chatbot.chatUrl}/assets/js/bootstrap.min.js`,
            'embedded-messaging-bootstrap'
        );
        initEmbeddedMessaging();
    });

    onBeforeUnmount(() => {
        destroyEmbeddedMessaging();
    });

    watch(
        () => lang.value,
        (newLang) => {
            // @ts-expect-error Salesforce global
            const esb = window.embeddedservice_bootstrap;
            if (!esb) return;

            esb.settings.language = newLang || 'de';
        }
    );
</script>
<!-- eslint-disable-next-line vue/valid-template-root -->
<template>
    <!-- Renderless component for chatbot functionality -->
</template>
